const textId = {
  // NAVBAR
  navbarHome: "Beranda",
  navbarSelectVehicle: "Pilih Kendaraan",
  navbarPriceList: "Daftar Harga",
  navbarHelp: "Bantuan",
  navbarBlog: "Blog",
  navbarTransaction: "Daftar Transaksi",
  navbarOutcomeTransaction: 'Daftar Transaksi Pengeluaran',
  navbarListVehicle: "Daftar Kendaraan",

  // HEADER
  welcomeHeaderPartOne: "Sewa kendaraan di Bali mulai",
  welcomeHeaderPartTwo: "100",
  welcomeHeaderPartThree: "ribuan saja",
  bodyJargon: "Sewa kendaraan dimanapun dan kapanpun dengan mudah",
  benefitHeaderOne: "Bisa Antar dimana Saja",
  benefitHeaderTwo: "Gratis Pembatalan",
  benefitHeaderThree: "100+ Mobil dan Motor",
  benefitCaptionOne: "Kami bisa mengantar kendaraan ke lokasi anda. Biaya pengantaran gratis untuk beberapa lokasi tertentu",
  benefitCaptionTwo: "Gratis pembatalan sewa kendaraan jika anda berubah pikiran. Tidak ada biaya pembatalan",
  benefitCaptionThree: "Kami memiliki lebih dari 100 kendaraan yang bisa anda sewa. Mulai dari mobil hingga motor",

  // HEADER FORM
  headerFormRentNow: "Pesan Sekarang",
  headerFormPickUpLocation: "Lokasi Antar Kendaraan",
  headerFormPickUpLocationPlaceholder: "Pilih Lokasi",
  headerFormPickUp: "Mulai Sewa",
  hedaerFormPickUpPlaceHolder: "Pilih Tanggal",
  hedaerFormPickUpTimePlaceHolder: "Pilih Waktu",
  headerFormDropOff: "Selesai Sewa",
  headerFormDropOffPlaceHolder: "Pilih Tanggal",
  headerFormDropOffTimePlaceHolder: "Pilih Waktu",
  headerFormContinueBooking: "Lanjutkan Pemesanan",
  headerFormSubmit: "Submit",
  seePriceList: "Daftar Harga →",

  // CHECKOUT
  checkoutForm: "Checkout",
  checkoutVehicle: "Jenis Motor/mobil yang disewa",
  checkoutVehiclePlaceholder: "Pilih kendaraan",
  checkoutVoucher: "Kode Voucher",
  checkoutVoucherPlaceholder: "Masukkan Kode Voucher",
  checkoutTypeVehicle: "Tipe Kendaraan",
  checkoutTypeMatic: "- Matic",
  checkoutTypeManual: "- Manual",
  checkoutTypeElectric: "- Electric",
  checkoutTermAndCondition: "Saya setuju dengan syarat dan ketentuan",
  checkoutReadTermAndCondition: "Baca syarat dan ketentuan",
  checkoutPaymentDetail: "Rincian Pembayaran",
  checkoutPaymentRentPrice: "Harga Sewa",
  checkoutPaymentDiscountVoucher: "Diskon Voucher",
  checkoutPaymentAdminFee: "Biaya Admin",
  checkoutPaymentTotal: "Total",
  checkoutName: "Nama Lengkap",
  checkoutNamePlaceholder: "Masukkan Nama Lengkap",
  checkoutEmail: "Email",
  checkoutEmailPlaceholder: "Masukkan Email",
  checkoutPhoneNumber: "No Telp",
  checkoutPhoneNumberPlaceholder: "Masukkan Nomor Telepon",
  checkoutAddressBali: "Alamat Lengkap di Bali",
  checkoutAddressBaliPlaceholder: "Masukkan Alamat Lengkap di Bali",
  checkoutCityKtp: "Kota sesuai KTP",
  checkoutCityKtpPlaceholder: "Masukkan Kota sesuai KTP",
  checkoutInstagram: "Instagram",
  checkoutInstagramPlaceholder: "Masukkan akun Instagram",
  checkoutStartRent: "Tanggal/Jam Mulai Sewa",
  checkoutEndRent: "Tanggal/Jam Akhir Sewa",
  checkoutPurpose: "Keperluan Sewa",
  checkoutPurposePlaceholder: "Masukkan keperluan sewa",
  checkoutStatus: "Status (Pilih 1)",
  checkoutStatusStudent: "Mahasiswa",
  checkoutStatusTourist: "Wisatawan",
  checkoutStatusEmployee: "Karyawan",
  checkoutWebMaintenance: "Checkout via web masih dalam pemeliharaan. Silakan pesan melalui WhatsApp.",
  checkoutRequired: "Wajib diisi",
  checkoutPaymentMethod: "Metode Pembayaran",
  bri: "BRI",
  bca: "BCA",
  mandiri: "Mandiri",
  accountBankName: "a.n Kadek Dwi Bagus",
  or: "atau",

  // ORDER
  orderMyOrder: "Pesanan Saya",
  orderNumber: "No. Pesanan",
  orderStatus: "Status",
  orderTransferBefore: "Transfer sebelum",
  orderWaitingPayment: "Menunggu pembayaran",
  orderPaymentSuccess: "Pembayaran berhasil",
  orderName: "Nama penerima :",
  orderEmail: "Email :",
  orderPhoneNumber: "Nomor telepon :",
  orderVehicle: "kendaraan :",
  orderTypeVehicle: "Tipe Kendaraan :",
  orderPickUp: "Mulai sewa :",
  orderDropOff: "Selesai sewa :",
  orderLocation: "Lokasi antar :",
  orderVoucher: "Kode voucher :",
  orderChangePaymentMethod: "Ubah metode pembayaran",
  orderChangeOrderDetail: "Ubah detail pesanan",
  orderChangeVehicle: "Ubah kendaraan",

  // BODY LANDING
  bodyBestDeals: "Penawaran Terbaik",

  // FOOTER
  greeting: 'Hallo, {name}!',
  instagram: 'Instagram',
  tiktok: 'Tiktok',
  whatsapp: 'Whatsapp',
  aboutUs: 'Tentang Kami',
  contactUs: 'Hubungi Kami',
  help: 'Bantuan',
  location: 'Lokasi',
  socialMedia: 'Media Sosial',
  company: 'Perusahaan',

  // ITEM
  itemOrderVehicle: "Pesan",
  itemStartFrom: "mulai dari",

  // LIST ITEM 
  listItemVehicle: "Kendaraan",
  listItemVehicleAll: "Semua Kendaraan",
  listItemVehicleItem1: "Motor",
  listItemVehicleItem2: "Mobil",
  listItemTypeVehicle: "Tipe kendaraan",
  listItemTypeVehicleAll: "Semua Tipe",
  listItemTypeVehicleItem1: "Matic",
  listItemTypeVehicleItem2: "Manual",
  listItemTypeVehicleItem3: "Electric",

  // PRICE LIST
  priceListVehicle: "Kendaraan",
  priceListName: "Nama",
  priceListTypeVehicle: "Tipe",
  priceListPrice: "Harga",
  priceListPricePerDay: "Harga/hari",
  priceListPricePerMonth: "Harga/bulan",
  priceListDetail: "Detail",

  // HELP
  helpNeedHelp: "Butuh Bantuan?",
  helpNeedHelpCaption: "Masukkan pertanyaan anda dan My Bali Rent Car akan secepat mungkin menghubungi anda",
  helpName: "Nama",
  helpNamePlaceholder: "Masukkan Nama",
  helpEmail: "Email",
  helpEmailPlaceholder: "Masukkan Email",
  helpPhoneNumber: "Nomor Telepon (WhatsApp)",
  helpPhoneNumberPlaceholder: "Masukkan Nomor Telepon",
  helpMessage: "Pesan",
  helpMessagePlaceholder: "Masukkan Pesan",
  helpSend: "Kirim",

  // util
  validateNik: "Validasi NIK",
  updateDescription: "Update Deskripsi",
  "Unpaid Transaction": "Transaksi Belum Lunas",

  // TNC
  tncTitle: "Syarat dan Ketentuan",
  tnc1: "Harga sewa kendaraan dihitung untuk penggunaan per hari (24 jam). Lebih dari itu akan dikenakan biaya tambahan sesuai dengan harga sewa kendaraan per harinya.",
  tnc2: "Pembayaran sewa kendaraan dilakukan secara tunai dimuka, dapat dibayar melalui transfer bank maupun tunai sebelum tanggal pelaksanaan sewa kendaraan.",
  tnc3: "Bagi penyewa yang menyewa mobil harus memiliki SIM A dan yang menyewa motor harus memiliki SIM C.",
  tnc4: "Foto penyewa beserta kartu identitas penyewa akan diambil untuk keperluan identifikasi.",
  tnc5: "Penyewa tidak diizinkan memberikan kendaraan untuk dikendarai orang lain dan tidak diizinkan untuk mengendarai kendaraan ke luar pulau Bali tanpa persetujuan MY BALI RENT CAR.",
  tnc6: "Pemakaian kendaraan sewa bukan untuk kegiatan-kegiatan yang bersifat melanggar norma agama, masyarakat dan hukum yang berlaku di Indonesia.",
  tnc7: "Segala kerusakan/kehilangan yang timbul akibat kelalaian penyewa akan ditanggung oleh penyewa dengan biaya yang disepakati oleh MY BALI RENT CAR",
  tnc8: "Wajib follow instagram MY BALI RENT CAR (mybalirentcar) selama periode sewa.",
  tnc9: "Wajib memberitahu MY BALI RENT CAR jika pindah tempat tinggal. PINDAH TANPA memberitahu dikenakan denda Rp 500.000",

  // DUMMY TEXT
  dummyText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla vitae diam euismod, aliquam nisl ac, tincidunt sapien. Nul",
  dummyTnc: "1. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla vitae diam euismod, aliquam nisl."
};

export default textId;
